import { nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";

// AppClassList - ONE COPY of space-separated class-list arithmetic (fix campaign 2026-10-15): the non-empty
// tokens of a class list. Pure, cannot throw; the callers that own a fault boundary keep it. The three
// copies this replaces: `AppReactRules.OthersOf`, `AppTaskFrame.Without`, `AppReactions.Classes`.

export class AppClassList {
    /** The non-empty tokens of `List`, in order, empties dropped. */
    public static Tokens = (List: string): string[] => {
        const Out: string[] = [];
        for (const One of nz(List).split(" ")) {
            if (One.length === 0) { continue; }
            Out.push(One);
        }
        return Out;
    };
}
